import {
  type KycActiveProcess,
  KycProvider,
  type KycResponse,
} from '@repo/api-kit/queries/due-diligence/kyc';

export function getProviderType(
  kycInfo?: KycResponse | null,
  contextProvider?: KycActiveProcess['provider']
) {
  return kycInfo?.activeProcess?.provider ?? contextProvider ?? KycProvider.PROVIDER_UNSPECIFIED;
}
